import { DefaultTheme } from "styled-components";

export const lightTheme: DefaultTheme = {
  splash: {
    bg: "rgb(240, 240, 240)",
    gradient:
      "linear-gradient(90deg,rgba(240, 240, 240, 0.5) 0,rgba(240, 240, 240, 0.5) 33.33%,rgba(240, 240, 240, 0) 44.1%,rgba(240, 240, 240, 0) 55.8%, rgba(240, 240, 240, 0.5) 66.66%, rgba(240, 240, 240, 0.5))",
    logoFill: "rgb(191, 191, 191)",
    progressBg: "rgb(230, 230, 230)",
    progressAfterBg: "#42CBA5",
    titleColor: "#525252",
    subTitleColor: "rgba(0, 0, 0, 0.45)",
    iconColor: "rgba(0, 0, 0, 0.25)",
  },
  layout: {
    bg: "#dadbd3",
    contentBoxShadowColor: "0 1px 1px 0 rgba(0, 0, 0, 0.06), 0 2px 5px 0 rgba(0, 0, 0, 0.2)",
  },
  sidebar: {},
  search: {
    iconColor: "#00a884",
  },
  options: {
    bg: "#d5d5d5",
    boxShadow: "0 2px 5px 0 #00000042, 0 2px 10px 0 rgba(0, 0, 0, 0.16)",
  },
  chatRoom: {
    bg: "#efeae2",
    scrollBtnBoxShadow: "0 1px 1px 0 rgba(0, 0, 0, 0.06), 0 2px 5px 0 rgba(0, 0, 0, 0.2)",
    profileBoxShadow: "rgba(0, 0, 0, 0.08) 0px 1px 3px 0px",
    profileHeadingColor: "#00a884",
    profileActionColor: "rgb(223, 51, 51)",
  },
  common: {
    borderColor: "#e9edef",
    primaryColor: "#f0f2f5",
    mainHeadingColor: "#111b21",
    subHeadingColor: "#54656f",
    secondaryColor: "#ffffff",
    tertiaryColor: "#00a884",
    readIconColor: "#0da9e5",
    unreadIconColor: "#b3b3b3",
    headerIconColor: "#54656f",
  },
  badge: {
    textColor: "#41525d",
    bgColor: "#e7f3ff",
  },
  sentMessage: {
    textColor: "#000",
    bgColor: "#d9fdd3",
  },
  receivedMessage: {
    textColor: "#000",
    bgColor: "#ffffff",
  },
  encryptionMessage: {
    bgColor: "#fef3c7",
    textColor: "#41525d",
  },
};
